import {SocItem} from "../../../domain/SocItem";
import {Grid, Typography} from "@material-ui/core";
import {SectionProps} from "../SectionProps";
import {Controller} from "react-hook-form";
import {Error} from "../../common/Error";
import {TextField} from "@ofqual/portal-components/components/TextField";
import {fieldLabels} from "../fieldLabels";

export const QuestionFourSection: React.FC<SectionProps<SocItem>> = (
    sectionProps
) => {
    const {control, disabled, errors} = sectionProps;

    return (
        <>
            <Grid item xs={12} sm={12}>
                <Typography variant="h6">
                    Key Financial Risks and Opportunities
                </Typography>
                <Typography variant="body1">
                    Customer risk (also known as counterparty risk) has been identified as an emerging risk that could
                    materially impact your financial performance. This group of risks includes:
                    <ul>
                        <li>Customers paying late;</li>
                        <li>Customers not being able to pay;</li>
                        <li>Customers leaving the market (and thereby reducing future business).</li>
                    </ul>
                    Customers could include schools, colleges, independent training providers, employers, charities, or
                    individual learners / teachers. We therefore want to understand how you identify, prevent and manage
                    this risk as required by Condition A6.
                </Typography>
                <Controller
                    control={control}
                    rules={{maxLength: 10000, required: true}}
                    name="customerRisksIdentifiedInformation"
                    as={
                        <TextField
                            label={fieldLabels.customerRisksIdentifiedInformation}
                            readOnly={disabled}
                            data-test="customerRisksIdentifiedInformation-field"
                            rows={8}
                            multiline
                            required
                            style={{marginTop: "10px"}}
                        />
                    }
                />
                {errors.customerRisksIdentifiedInformation?.type === "maxLength" && (
                    <Error data-test="customerRisksIdentifiedInformation-validation">
                        Must be no more than 10,000 characters
                    </Error>
                )}
                {errors.customerRisksIdentifiedInformation?.type === "required" && (
                    <Error data-test="customerRisksIdentifiedInformation-validation">
                        This field is required
                    </Error>
                )}

            </Grid>
            <Grid item xs={12} sm={12}>
                <Controller
                    control={control}
                    rules={{maxLength: 10000, required: true}}
                    name="customerRisksManagedInformation"
                    as={
                        <TextField
                            label={fieldLabels.customerRisksManagedInformation}
                            readOnly={disabled}
                            data-test="customerRisksManagedInformation-field"
                            rows={8}
                            multiline
                            required
                        />
                    }
                />
                {errors.customerRisksManagedInformation?.type === "maxLength" && (
                    <Error data-test="customerRisksManagedInformation-validation">
                        Must be no more than 10,000 characters
                    </Error>
                )}
                {errors.customerRisksManagedInformation?.type === "required" && (
                    <Error data-test="customerRisksManagedInformation-validation">
                        This field is required
                    </Error>
                )}
            </Grid>
            
            <Grid item xs={12} sm={12}>
                <Typography>
                    {fieldLabels.financialRisksInformation}
                </Typography>
                <Controller
                    control={control}
                    rules={{maxLength: 10000, required: true}}
                    name="financialRisksInformation"
                    as={
                        <TextField
                            label={fieldLabels.pleaseEnterYourResponse}
                            readOnly={disabled}
                            data-test="financialRisksInformation-field"
                            rows={8}
                            multiline
                            required
                        />
                    }
                />
                {errors.financialRisksInformation?.type === "maxLength" && (
                    <Error data-test="financialRisksInformation-validation">
                        Must be no more than 10,000 characters
                    </Error>
                )}
                {errors.financialRisksInformation?.type === "required" && (
                    <Error data-test="financialRisksInformation-validation">
                        This field is required
                    </Error>
                )}
            </Grid>
        </>
    );
};
